module.exports = __webpack_public_path__ + "static/media/collection1.4d410b9f.png";